import { config } from './config';
import axios from "axios";

export const administrationAccountManagerService = {
    getAll,
    config
};

export function getAll(filters) {

    let axiosConfig = {};

    axiosConfig['params'] = filters || {};
    axiosConfig['params']['is_active'] = 'True'

    return new Promise((resolve, reject) => {
      axios
        .get(`${config.apiUrl}/api/administration/account-managers/`, axiosConfig)
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}